import React, { useEffect } from "react";
import Header from "../../../commons/header/Header";
import Wrapper from "../../../commons/wrapper/Wrapper";
import { strings } from "intl/fa";
import styles from "./OrdersList.module.scss";
import { OrganizationAuthState } from "./organizationAuthState/OrganizationAuthState";
import { OrdersTab, useOrderTabs } from "./tabs/orderTabs.utils";
import { Tabs } from "../../../commons/tabs/Tabs";
import { useNavigate, useLocation } from "react-router-dom";
import {
  AppPage,
  AppPageUrls,
} from "../../../../core/navigation/navigation.slice";
import { useIsVip } from "../../../../hooks/useFeatureScopes";
import { useNeedAuth } from "hooks/useNeedAuth";

const OrdersList: React.FC<React.PropsWithChildren<unknown>> = () => {
  const isVip = useIsVip();
  const { tabsHandler, List } = useOrderTabs();
  const { isOrganization, isAuthenticating } = useNeedAuth();
  const search = useLocation().search;
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(search);
    navigate(`${AppPageUrls[AppPage.OrdersList]}?${params.toString()}`, {
      replace: true,
    });
    const type = params.get("type");
    if (type === "a") {
      tabsHandler.onChangeTab(
        tabsHandler.tabs.filter((tab) => tab.id === OrdersTab.Ads)[0]
      );
    }
  }, []);

  return (
    <Wrapper className={styles.Wrapper}>
      <Header title={strings.ad_sale.title} />
      {isVip && <Tabs {...tabsHandler} />}
      <List disableButton={isOrganization && isAuthenticating}>
        {isOrganization && isAuthenticating && <OrganizationAuthState />}
      </List>
    </Wrapper>
  );
};

export default OrdersList;
